var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMembershipCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 6.35693H18.1422M15.9993 10.6426H18.1422M5.46716 11.7141C5.68803 11.0862 6.09834 10.5424 6.64147 10.1577C7.18459 9.77305 7.83374 9.56644 8.49931 9.56644C9.16487 9.56644 9.81402 9.77305 10.3571 10.1577C10.9003 10.5424 11.3106 11.0862 11.5314 11.7141",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49997 9.57087C9.68344 9.57087 10.6428 8.61148 10.6428 7.42801C10.6428 6.24455 9.68344 5.28516 8.49997 5.28516C7.31651 5.28516 6.35712 6.24455 6.35712 7.42801C6.35712 8.61148 7.31651 9.57087 8.49997 9.57087Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 1H3.14286C1.95939 1 1 1.95939 1 3.14286V13.8571C1 15.0406 1.95939 16 3.14286 16H20.2857C21.4692 16 22.4286 15.0406 22.4286 13.8571V3.14286C22.4286 1.95939 21.4692 1 20.2857 1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembershipCard);
export default __webpack_public_path__ + "static/media/icon-membership-card.054a9f24afa6cdf2053bea0c19bc431f.svg";
export { ForwardRef as ReactComponent };